export const config = {
    publicPortalApiUrl: "/api/public-portal",
    paymentIntegrationsApiUrl: "/api/payment-integrations",
    identityApiUrl: "/api/identity"
};